export default __webpack_public_path__ + "static/media/callIconHCSelected.24aa447f.svg";